import { LoadingButton } from '@mui/lab'
import { Box, InputLabel, TextField } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

const KybEditAssignedUsersReason = ({ onSubmit, isLoading }) => {
  const { t } = useTranslation(['common', 'messages'])
  const [reasonText, setReasonText] = useState('')

  return (
    <>
      <Box className="modal-box">
        <InputLabel>{t('messages:kyb.editDesignatedUsersReason')}:</InputLabel>
        <TextField
          multiline
          placeholder={t('messages:minCharacters')}
          required
          onChange={(e) => setReasonText(e.target.value)}
        />
      </Box>
      <Box className="modal-button">
        <LoadingButton
          size="small"
          color="secondary"
          variant="contained"
          loading={isLoading}
          disabled={reasonText.length < 5}
          onClick={() => onSubmit(reasonText)}
        >
          {t('common:save')}
        </LoadingButton>
      </Box>
    </>
  )
}

export default KybEditAssignedUsersReason
